import React, { useEffect, useState } from "react";
import { api, fmtNum } from "@/lib/api";
import StatusBadge from "@/components/StatusBadge";
import { Loader2 } from "lucide-react";

const COLORS = { PMS: "#12346B", AGO: "#F47920", DPK: "#059669", ATK: "#7C3AED" };
const colorFor = (n = "") => COLORS[Object.keys(COLORS).find((k) => n.includes(k))] || "#64748B";

function TankCard({ t }) {
  const avail = t.available;
  const pct = Math.min(100, (t.current_stock / t.capacity) * 100);
  const c = colorFor(t.product_name);
  return (
    <div className="bg-white border border-slate-200 rounded-lg p-4" data-testid={`tank-card-${t.tank_no.toLowerCase()}`}>
      <div className="flex items-center justify-between mb-3">
        <div>
          <div className="font-head font-bold text-slate-900 mono">{t.tank_no}</div>
          <div className="text-xs text-slate-500">{t.product_name}</div>
        </div>
        <StatusBadge status={t.status} />
      </div>
      <div className="flex items-center gap-4">
        <div className="relative w-16 h-32 rounded-md border-2 border-slate-300 bg-slate-50 overflow-hidden shrink-0">
          <div className="absolute bottom-0 left-0 right-0" style={{ height: `${pct}%`, backgroundColor: c, opacity: 0.85 }} />
          <div className="absolute inset-0 flex items-center justify-center">
            <span className="text-xs font-bold text-slate-800 bg-white/70 px-1 rounded tabular">{pct.toFixed(0)}%</span>
          </div>
        </div>
        <div className="flex-1 space-y-1.5 text-xs">
          <Row label="Capacity" value={`${fmtNum(t.capacity)} L`} />
          <Row label="Current Stock" value={`${fmtNum(t.current_stock)} L`} strong />
          <Row label="Reserved" value={`${fmtNum(t.reserved)} L`} />
          <Row label="Allocated" value={`${fmtNum(t.allocated)} L`} />
          <Row label="Available" value={`${fmtNum(avail)} L`} tone="green" strong />
          <Row label="Calibration" value={t.calibration_status} />
        </div>
      </div>
    </div>
  );
}
const Row = ({ label, value, strong, tone }) => (
  <div className="flex justify-between">
    <span className="text-slate-500">{label}</span>
    <span className={`tabular ${strong ? "font-semibold" : ""} ${tone === "green" ? "text-emerald-600" : "text-slate-800"}`}>{value}</span>
  </div>
);

export default function Tanks() {
  const [tanks, setTanks] = useState(null);
  useEffect(() => { api.get("/tanks").then(({ data }) => setTanks(data)).catch(() => setTanks([])); }, []);
  if (!tanks) return <div className="py-20 text-center text-slate-400"><Loader2 className="h-6 w-6 animate-spin inline" /></div>;
  return (
    <div>
      <div className="mb-5">
        <h1 className="font-head text-2xl font-bold tracking-tight text-slate-900">Tanks & Inventory</h1>
        <p className="text-sm text-slate-500 mt-0.5">Storage capacity, stock levels and availability across the terminal.</p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
        {tanks.map((t) => <TankCard key={t.id} t={t} />)}
      </div>
    </div>
  );
}
